import { useState } from 'react';
import { useTournament } from '../context/TournamentContext';
import { PlayerStatsTable } from '../components/PlayerStatsTable';
import { BarChart3, Bird, Star, Users, Hash } from 'lucide-react';
import { PartnersCard } from '../components/PartnersCard';

const iconLabel: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.3rem',
};

export function PlayerStatsPage() {
  const { playerStats, teams, isLoading } = useTournament();
  const [teamFilter, setTeamFilter] = useState('');

  if (isLoading) {
    return <div className="loading-container"><div className="spinner" /></div>;
  }

  return (
    <div>
      <h1 className="mb-lg" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <BarChart3 size={28} />
        Hráčské statistiky
      </h1>

      {/* Summary cards */}
      {playerStats.length > 0 && (
        <div className="grid-4 mb-lg">
          <div className="stat-card">
            <div className="stat-card-value" style={{ color: '#f59e0b' }}>
              {playerStats.reduce((sum, s) => sum + s.eagles, 0)}
            </div>
            <div className="stat-card-label" style={iconLabel}>
              <Star size={14} color="#f59e0b" />
              Celkem Eagles
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-card-value" style={{ color: 'var(--success)' }}>
              {playerStats.reduce((sum, s) => sum + s.birdies, 0)}
            </div>
            <div className="stat-card-label" style={iconLabel}>
              <Bird size={14} color="var(--success)" />
              Celkem Birdie
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-card-value">
              {playerStats.length}
            </div>
            <div className="stat-card-label" style={iconLabel}>
              <Users size={14} />
              Hráčů
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-card-value" style={{ color: 'var(--accent)' }}>
              {playerStats.reduce((sum, s) => sum + s.totalHolesPlayed, 0)}
            </div>
            <div className="stat-card-label" style={iconLabel}>
              <Hash size={14} />
              Odehraných jamek
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <PlayerStatsTable
          stats={playerStats}
          teamFilter={teamFilter}
          onTeamFilterChange={setTeamFilter}
          teams={teams.map(t => ({ id: t.id, name: t.name, color: t.color }))}
        />
      </div>

      <div className="mt-lg">
        <PartnersCard />
      </div>
    </div>
  );
}
